import { Link } from "@inertiajs/react";
import { Button } from "@/components/ui/button";
import { Keyboard, Moon, Sun } from "lucide-react";
import { SidebarTrigger } from "@/components/ui/sidebar";

interface AppHeaderProps {
  onOpenShortcuts: () => void;
  onToggleTheme: () => void;
  showSidebarToggle?: boolean;
}

export default function AppHeader({
  onOpenShortcuts,
  onToggleTheme,
  showSidebarToggle = false,
}: AppHeaderProps) {
  return (
    <header className="sticky top-0 z-40 flex h-12 shrink-0 items-center gap-2 border-b bg-background px-4">
      <Link href="/" className="flex items-center gap-2">
        <div className="flex h-7 w-7 items-center justify-center">
          <img src="/icon.svg" alt="Logo" className="h-5 w-5 filter invert dark:invert-0" />
        </div>
        <span className="text-sm font-semibold">برنامج ادارة الموارد</span>
      </Link>
      <div className="flex flex-1 items-center justify-end gap-2">
        <Button
          variant="ghost"
          size="icon"
          onClick={onOpenShortcuts}
          className="relative hidden md:inline-flex"
          aria-label="Keyboard shortcuts"
        >
          <Keyboard className="h-5 w-5" />
        </Button>
        {showSidebarToggle && <SidebarTrigger className="md:hidden" aria-label="Toggle sidebar" />}
        <Button
          variant="ghost"
          size="icon"
          onClick={onToggleTheme}
          className="relative"
          aria-label="Toggle theme"
        >
          <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0" />
          <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
        </Button>
      </div>
    </header>
  );
}
